import * as React from "react";
import { useReactToPrint } from "react-to-print";
import { ReactComponent as PrintIcon } from "./../../assets/images/icons/Google SVGs/print.svg";
import { FunctionalComponentToPrint } from "./componentToPrint";
import { useState, useRef, useCallback } from "react";

const FunctionalComponentWithHook = (props) => {
  const componentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const text = props.text ?? "";
  const subtext = props.subtext ?? null;
  const targetLink = props.targetLink ?? window.location.href;

  const handleAfterPrint = useCallback(() => {
    setLoading(false);
  }, []);

  const handleBeforePrint = useCallback(() => {
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoading(true);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        setLoading(false);
      }, 500);
    });
  }, []);

  const reactToPrintContent = useCallback(() => {
    return componentRef.current;
  }, []);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "پذیرکس | اشتراک‌گذاری",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <>
      <div
        className={`btn bg-iso-blue-300 color-iso-white border-radius-8 fs-16 fw-normal py-1 mt-2${
          loading ? " disabled" : ""
        }`}
        onClick={handlePrint}
      >
        {loading ? "کمی صبر کنید..." : "پرینت"}
        <PrintIcon width={24} className="ms-2" />
      </div>
      <FunctionalComponentToPrint
        ref={componentRef}
        text={text}
        subtext={subtext}
        targetLink={targetLink}
      />
    </>
  );
};

export default FunctionalComponentWithHook;
